import React, { useEffect, useRef } from "react";
import Header from "../../components/header/header";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import TimeFormat from "../../components/timeFormat/timeFormat";
import { approveDeactivateUserAction, deleteUserAction, getUserListingAction, reactiveUserAction, updateUserAdvisor } from "../../actions/user";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import UserMakeAdvisor from "./UserMakeAdvisor";
import UserReactivateModal from "./UserReactivateModal";

export default function UserManager() {
  const [page, setPage] = useState(1);
  const [activePage, setActivePage] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [userId, setUserId] = useState(null);
  const [type, setType] = useState(false);
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  const [actionType, setActionType] = useState(""); // "deactivate" | "permanentDelete" | "reactivate" | "deny"
  const [reactivateModal, setReactivateModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const { userList, userListCount, userListLink } = useSelector(
    (state) => state.user
  );
  const timeoutRef = useRef(null);
  useEffect(() => {
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current);
    }
    if (search !== "") {
      timeoutRef.current = setTimeout(() => {
        dispatch(getUserListingAction(page, 20, search));
      }, 500);
    } else {
      dispatch(getUserListingAction(page, 20, search));
    }
    return () => {
      clearTimeout(timeoutRef.current);
    };

  }, [page, dispatch, activePage, search]);

  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setActivePage(selectedPage);
    setPage(selectedPage + 1);
  };


  const openConfirmPopup = (id, type) => {
    setUserId(id)
    setType(type)
    setOpenModal(true)
  }

  const makeAdvisor = async () => {
    if (userId) {
      let payload = {
        isAdvisor: type,
      }
      await dispatch(updateUserAdvisor(userId, payload));
      setActivePage(0);
      setPage(1);
      dispatch(getUserListingAction(page, 20, search));
      setOpenModal(false)
      setUserId(null)
      setType(false)
    }
  }
  const handleConfirmAction = async () => {
    if (!selectedUser) return;

    let payload = {
      id: selectedUser._id
    };

    try {
      if (actionType === "deactivate") {
        await dispatch(approveDeactivateUserAction(payload));
      }

      if (actionType === "permanentDelete") {
        setIsDeleting(true);
        const response = await dispatch(deleteUserAction(selectedUser._id));
        if (!response?.status) return;
      }

      if (actionType === "deny") {
        await dispatch(reactiveUserAction({
          id: selectedUser._id,
          isDeleteRequested: false
        }));
      }

      if (actionType === "reactivate") {
        await dispatch(reactiveUserAction({
          id: selectedUser._id,
          isDeleteRequested: false
        }));
      }

      setReactivateModal(false);
      setSelectedUser(null);
      setActionType("");
      setActivePage(0);
      setPage(1);
      dispatch(getUserListingAction(1, 20, search));

    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      if (actionType === "permanentDelete") {
        setIsDeleting(false);
      }
    }
  };
  return (
    <>
      <Header title="Notification Manager" />
      <div className="container-fluid py-4">
        <div className="row">
          <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12 mb-2">
            <div className="card planList notification h-100">
              <div className="card-header">
                <div className="searchbar">
                  <input
                    type="search"
                    placeholder="Search user by email.."
                    name="search"
                    id=""
                    autoComplete="off"
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value.trimLeft());
                    }}
                  />
                  <img src="assets/img/searchIcon.svg" alt="" />
                  {/* <h6 className="font-weight-bolder payment-text mb-0">
                    Users
                  </h6> */}
                </div>
              </div>
              <div className="card-body detail">
                <table className="businessTable userTable">
                  <thead>
                    <tr>
                      {/* <td>Make advisor</td> */}
                      <td>Name</td>
                      <td>Email</td>
                      <td>Verification status</td>
                      <td>Public user</td>
                      <td>From user</td>
                      {/* <td>Email verification link</td> */}
                      <td>Forgot Password link</td>
                      <td>Registration date</td>
                      <td>Action</td>
                    </tr>
                  </thead>
                  <tbody>
                    {userList.length > 0 ? (
                      userList?.map((ele, eleIndex) => (
                        <tr key={eleIndex}>
                          {/* <td>
                            <input
                              maxLength={50}
                              autoComplete="off"
                              onChange={(e) =>
                                openConfirmPopup(ele?._id, e.target.checked)
                              }
                              type="checkbox"
                              checked={ele.isAdvisor}
                            />
                          </td> */}
                          <td>
                            <h6 className="profile-text text-sm">
                              {ele.first_name + " " + ele.last_name || "-"}
                            </h6>
                          </td>
                          <td>
                            <h6 className="profile-text text-sm">
                              {ele.email || "-"}
                            </h6>
                          </td>
                          <td>
                            <h6 className="profile-text text-sm">
                              {
                                !ele.isEmailVerified
                                  ? "Non-Active"
                                  : ele.isDeleteRequested
                                    ? "Pending Deactivation"
                                    : !ele.isActive
                                      ? "Deactivated"
                                      : "Active"
                              }
                            </h6>
                          </td>
                          <td>
                            <h6 className="profile-text text-sm">
                              {ele.isPublicUser ? "Yes" : "No"}
                            </h6>
                          </td>
                          <td>
                            <h6 className="profile-text profile-text-fromuser text-sm">
                              {ele?.referredByUser?.first_name || "-"}{" "}
                              {ele?.referredByUser?.first_name &&
                                ele?.referredByUser?.last_name}
                            </h6>
                            <p className="profile-text profile-text-fromuser text-sm">
                              {ele?.referredByUser?.email}
                            </p>
                          </td>
                          {/* <td>
                            <h6 className="profile-text text-sm">
                              {!ele.isEmailVerified
                                ? (
                                  <>
                                    <CopyToClipboard
                                      text={
                                        userListLink +
                                        "verify-email/" +
                                        ele.token
                                      }>
                                      <div
                                        className="pointer"
                                        onClick={($event) => {
                                          toast.success(
                                            "Copied to clipboard!"
                                          );
                                          $event.stopPropagation();
                                          $event.preventDefault();
                                        }}>
                                        Click to copy link{" "}
                                        <img
                                          src="assets/img/copyText.svg"
                                          alt=""
                                        />
                                      </div>
                                    </CopyToClipboard>
                                  </>
                                ) || "-"
                                : ""}
                            </h6>
                          </td> */}

                          <td>
                            <h6 className="profile-text text-sm">
                              {ele.forgetToken
                                ? (
                                  <>
                                    <CopyToClipboard
                                      text={
                                        userListLink +
                                        "reset-password/" +
                                        ele.forgetToken
                                      }>
                                      <div
                                        className="pointer"
                                        onClick={($event) => {
                                          toast.success(
                                            "Copied to clipboard!"
                                          );
                                          $event.stopPropagation();
                                          $event.preventDefault();
                                        }}>
                                        Click to copy link{" "}
                                        <img
                                          src="assets/img/copyText.svg"
                                          alt=""
                                        />
                                      </div>
                                    </CopyToClipboard>
                                  </>
                                ) || "-"
                                : ""}
                            </h6>
                          </td>
                          <td>
                            <h6 className="profile-text text-sm">
                              <TimeFormat time={ele.createdAt} />
                            </h6>
                          </td>
                          <td>
                            <div className="d-flex gap-2 align-items-center">
                              {ele?.isDeleteRequested && ele?.isActive && (
                                <button
                                  className="btn save-btn editButton"
                                  onClick={() => {
                                    setSelectedUser(ele);
                                    setActionType("deactivate");
                                    setReactivateModal(true);
                                  }}
                                >
                                  Deactivate
                                </button>
                              )}

                              {!ele?.isActive && (
                                <button
                                  className="btn save-btn editButton"
                                  onClick={() => {
                                    setSelectedUser(ele);
                                    setReactivateModal(true);
                                    setActionType("reactivate");
                                  }}
                                >
                                  Re-activate
                                </button>
                              )}

                              <button
                                type="button"
                                className="btn p-0 text-danger"
                                title="Delete user permanently"
                                aria-label={`Delete ${ele.email} permanently`}
                                onClick={() => {
                                  setSelectedUser(ele);
                                  setActionType("permanentDelete");
                                  setReactivateModal(true);
                                }}
                              >
                                <i className="fa-solid fa-trash-can" aria-hidden="true"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="d-flex pt-3">
                        <td className="d-flex flex-column justify-content-center">
                          <h6 className="mb-0 text-sm table-heading text-center">
                            No users found
                          </h6>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {userListCount > 1 && (
                <div className="pagination-section">
                  <ReactPaginate
                    previousLabel={"Prev"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={userListCount}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                    forcePage={activePage}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <UserMakeAdvisor addModalShow={openModal}
        addModalClose={() => setOpenModal(false)} makeadvisor={makeAdvisor} message={type ? "Are you sure you want to assign the selected users as advisor?" : "Are you sure you want to remove the advisor role from the selected user?"} />
      <UserReactivateModal
        show={reactivateModal}
        onClose={() => setReactivateModal(false)}
        onConfirm={handleConfirmAction}
        selectedUser={selectedUser}
        type={actionType}
        isDeleting={isDeleting}
      />
    </>
  );
}
